import React, { lazy, Suspense, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const V5Home = lazy(() => import('./v5/V5Home'));
const DocsLayout = lazy(() => import('../Docs/DocsLayout'));
const ChallengesPage = lazy(() => import('../Challenges/ChallengesPage'));
const ChallengeDetailPage = lazy(() => import('../Challenges/ChallengeDetailPage'));
const ChallengeFeedPage = lazy(() => import('../Challenges/ChallengeFeedPage'));

function Loader() {
    return <div style={{ minHeight: '100vh', background: '#060809', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#f4a261', fontFamily: 'system-ui', fontSize: '1.1rem' }}>Loading…</div>;
}

function ScrollToTop() {
    useEffect(() => {
        if ('scrollRestoration' in history) {
            history.scrollRestoration = 'manual';
        }
        if (!window.location.hash) {
            window.scrollTo(0, 0);
        }
    }, []);
    return null;
}

export default function LandingRouter({ children }) {
    const { pathname, search } = useLocation();
    const searchParams = new URLSearchParams(search);
    const hasAuthCode =
        searchParams.has('code') || searchParams.has('error');

    if ((pathname === '/' || pathname === '/landing') && !hasAuthCode) {
        return (
            <>
                <ScrollToTop />
                <Suspense fallback={<Loader />}>
                    <div className="sp-landing-root">
                        <V5Home />
                    </div>
                </Suspense>
            </>
        );
    }

    if (pathname === '/challenges') {
        return (
            <>
                <ScrollToTop />
                <Suspense fallback={<Loader />}>
                    <ChallengesPage />
                </Suspense>
            </>
        );
    }

    const challengeFeedMatch = pathname.match(/^\/challenges\/([^/]+)\/feed$/);
    if (challengeFeedMatch) {
        const slug = decodeURIComponent(challengeFeedMatch[1]);
        return (
            <>
                <ScrollToTop />
                <Suspense fallback={<Loader />}>
                    <ChallengeFeedPage slug={slug} />
                </Suspense>
            </>
        );
    }

    const challengeDetailMatch = pathname.match(/^\/challenges\/([^/]+)$/);
    if (challengeDetailMatch) {
        const slug = decodeURIComponent(challengeDetailMatch[1]);
        return (
            <>
                <ScrollToTop />
                <Suspense fallback={<Loader />}>
                    <ChallengeDetailPage slug={slug} />
                </Suspense>
            </>
        );
    }

    if (pathname.startsWith('/docs')) {
        return (
            <>
                <ScrollToTop />
                <Suspense fallback={<Loader />}>
                    <DocsLayout />
                </Suspense>
            </>
        );
    }

    if (pathname.startsWith('/landing/')) {
        return <Navigate to="/landing" replace />;
    }

    return children;
}
